import ListMetaRow from "./ListMetaRow";
import { GRADIENTS } from "../../theme";

export default function Letterbox({ date, tablet, gradients, showIcons, displayDates, image, title }) {
    return (
        <>
            <label className="letterbox" htmlFor="listImage1" style={{ width: "100%", boxSizing: "border-box", display: "flex", justifyContent: "space-between", marginBottom: "2rem" }}>
                <div className="tile-image" style={{ position: 'relative', width: "100%" }}>
                    <img src={image ? image : 'plus.png'} style={{ width: "100%", objectFit: "cover", borderRadius: "16px", height: tablet ? "34rem" : "24rem" }} alt="" />
                    <div style={{ position: "absolute", bottom: "2rem", left: "2rem", right: "2rem", zIndex: 20 }}>
                        <p style={{ fontSize: "35px", fontWeight: "500", margin: 0, marginBottom: "1rem", zIndex: 20 }}>{title}</p>
                        <ListMetaRow showIcons={showIcons} displayDates={displayDates} date={date} />
                    </div>
                    <div className='gradient' style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: GRADIENTS.imageOverlay, zIndex: 2, opacity: gradients ? "90%" : "0", borderRadius: "16px" }}>&nbsp;</div>
                </div>
            </label>
        </>
    )
}